/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ErrorDto } from './ErrorDto';
import type { Issuance } from './Issuance';

export type Transaction = {
    id: number;
    sponsorCode: string;
    totalMiles: number;
    type: Transaction.type;
    status?: Transaction.status;
    statusCode?: number;
    canUpdate: boolean;
    isEligibleForParticipationOffer?: boolean;
    errors?: Array<ErrorDto>;
    issuances?: Array<Issuance>;
};

export namespace Transaction {

    export enum type {
        POST = 'POST',
        ISSUE = 'ISSUE',
    }

    export enum status {
        SUCCESS = 'SUCCESS',
        PENDING = 'PENDING',
        ERROR = 'ERROR',
        BACKED_OUT = 'BACKED_OUT',
    }


}

